"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugNotification = void 0;
const tslib_1 = require("tslib");
const Api = tslib_1.__importStar(require("../privateRequest"));
const debugNotification = async (accountId) => {
    return await Api.get(`notifications/debug/${accountId}`);
};
exports.debugNotification = debugNotification;
